'use client';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import FullWrapper from 'core/FullWrapper';
import ScrollAnimation from 'core/ScrollAnimation';
import React, { useMemo, useState } from 'react';
import Slider from 'react-slick';
import { useMedia } from 'react-use';

import ClassicArrow from '~/components/features/company/CompanySlider/ClassicArrow';
import { historyData } from '~/components/features/company/CompanySlider/constants';

import cn from './style.module.sass';

export default function CompanySlider() {
    const isMobile = useMedia('(max-width: 750px)');

    let slider: unknown;

    const [slideIndex, setSlideIndex] = useState(0);

    const settings = useMemo(
        () => ({
            dots: false,
            infinite: false,
            speed: 500,
            slidesToScroll: 1,
            initialSlide: 0,
            button: false,
            variableWidth: !isMobile,
            buttons: false,
            beforeChange: (_current: unknown, next: React.SetStateAction<unknown>) => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                setSlideIndex(next);
            },
        }),
        [isMobile]
    );

    const prevSlide = () => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        slider.slickPrev();
    };

    const nextSlide = () => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        slider.slickNext();
    };

    return (
        <ScrollAnimation>
            <FullWrapper smallPaddings={true} isMargin={false} className={cn['history-block']}>
                <div className={cn['history-block__wrapper']}>
                    <h2 className={'h2 text-white'}>История</h2>
                    <div className={cn['history-slider__controls']}>
                        <ClassicArrow
                            isLeft={true}
                            onclick={prevSlide}
                            disabled={slideIndex === 0}
                        />
                        <ClassicArrow
                            onclick={nextSlide}
                            disabled={slideIndex === historyData.length - 1}
                        />
                    </div>
                </div>
                <div className={cn['history-slider']}>
                    <Slider ref={c => (slider = c)} className={cn['headermenu']} {...settings}>
                        {historyData.map(item => (
                            <div key={item.id} className={cn['history-slider__container']}>
                                <div className={'h2 text-white font-bold!'}>{item.year}</div>
                                <div className={cn['history-slider__wrapper']}>
                                    <div className={cn['history-slider__title']}>{item.title}</div>
                                    <div className={cn['history-slider__subtitle']}>
                                        {item.subtitle}
                                    </div>
                                    {item.text.length > 0 && (
                                        <div className={cn['history-slider__text']}>
                                            {item.text}
                                        </div>
                                    )}

                                    {item.content.length > 0 && (
                                        <div className={cn['history-slider__content']}>
                                            {item.content}
                                        </div>
                                    )}

                                    {item.subcontent.length > 0 && (
                                        <div className={cn['history-slider__subcontent']}>
                                            {item.subcontent}
                                        </div>
                                    )}
                                    {item.subtext.length > 0 && (
                                        <div className={cn['history-slider__subtext']}>
                                            {item.subtext}
                                        </div>
                                    )}
                                    {item.description?.length > 0 && (
                                        <div className={cn['history-slider__description']}>
                                            {item.description}
                                        </div>
                                    )}
                                    {item.subdescription?.length > 0 && (
                                        <div className={cn['history-slider__subdescription']}>
                                            {item.subdescription}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
}
